/**
 * 物件一覧（BukkenListPageBody）: カード「間取り」→ Magnific で間取りモーダル表示。
 * 詳細の bukken-detail-modal.js とは独立（先方取り込み・個別改修の影響を避ける）。
 */
import $ from 'jquery';

const MODAL_ID = 'bukken-list-floor-modal';
const DEFAULT_IMG = '/img/bukken_detail/img-sub-01.webp';
const DEFAULT_CAPTION = '専有面積76.45㎡のゆとりある2LDK';

function updateFloorContent(modalEl, layoutBtn) {
	const img = modalEl.querySelector('.js-bukken-list-floor-modal-image');
	const caption = modalEl.querySelector('.js-bukken-list-floor-modal-caption');
	if (!img) return;

	let src = layoutBtn?.dataset?.floorSrc?.trim() || '';
	let text = layoutBtn?.dataset?.floorCaption?.trim() || '';

	if (!src && layoutBtn) {
		const card = layoutBtn.closest('.bukkenList__card');
		const slider = card?.querySelector('.js-bukken-card-slider');
		const slides = slider?.querySelectorAll('.splide__slide');
		const secondSlide = slides?.[1];
		const slideImg = secondSlide?.querySelector('img');
		src = slideImg?.getAttribute('src') || '';
	}

	img.setAttribute('src', src || DEFAULT_IMG);
	if (caption) {
		caption.textContent = text || DEFAULT_CAPTION;
	}
}

function bindCloseOnce(modalEl) {
	if (!modalEl || modalEl.dataset.listFloorCloseBound === 'true') return;
	const closeBtn = modalEl.querySelector('.js-bukken-list-floor-close');
	if (closeBtn instanceof HTMLButtonElement) {
		closeBtn.addEventListener('click', () => {
			$.magnificPopup.close();
		});
	}
	modalEl.dataset.listFloorCloseBound = 'true';
}

export function init() {
	const modalEl = document.getElementById(MODAL_ID);
	if (!modalEl) return;

	const listRoot = document.querySelector('.bukkenList');
	if (!listRoot) return;

	bindCloseOnce(modalEl);

	if (listRoot.dataset.listFloorLayoutBound === 'true') return;
	listRoot.dataset.listFloorLayoutBound = 'true';

	listRoot.addEventListener(
		'click',
		(e) => {
			const layoutBtn = e.target.closest('.bukkenList__cardLayoutBtn');
			if (!layoutBtn || !listRoot.contains(layoutBtn)) return;
			e.preventDefault();
			e.stopPropagation();

			const setupOpen = () => {
				$.magnificPopup.open({
					items: {
						src: `#${MODAL_ID}`,
						type: 'inline',
					},
					closeBtnInside: true,
					mainClass: 'bukken-detail-floor-popup',
					callbacks: {
						open() {
							updateFloorContent(modalEl, layoutBtn);
						},
					},
				});
			};

			if ($.fn.magnificPopup) {
				setupOpen();
				return;
			}

			import('magnific-popup/dist/jquery.magnific-popup.js').then(setupOpen);
		},
		true
	);
}
